import { Button, Card, Col, Form, Input, Radio, Row, Typography, Select  } from "antd";
import styles from "./AddProdCat.module.css";
import { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPartyDiscount } from "../../redux/actions/partyDiscount/addPartyDiscountAction";
import UploadMany from "../Card/UploadMany";

const AddPartyDiscount = () => {
  const dispatch = useDispatch();
  const { Title } = Typography;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
	const allCustomer = useSelector((state) => state.customers.list);



  const onClick = () => {
    setLoading(true);
  };

  const onFinish = async (values) => {
    try {
      const resp = await dispatch(addPartyDiscount(values));
      if (resp.message === "success") {
        setLoading(false);
        form.resetFields();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
    console.log("Failed:", errorInfo);
  };

  return (
    <Fragment>
      <Row className="mr-top" justify="space-between" gutter={[0, 30]}>
        <Col xs={24} sm={24} md={24} lg={11} xl={11} className="rounded column-design">
          <Card bordered={false} className="criclebox h-full">
            <Title level={4} className="text-center" style={{ backgroundColor: "#dadada", padding: "10px", margin: "0 !important" }}>
              Add Product Currency
            </Title>
            <Form
              form={form}
              className=""
              name="basic"
              labelCol={{
                span: 7,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Discount Type"
                name="discountType"
                rules={[
                  {
                    required: true,
                    message: "Please select a discount type!",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="supplier">Supplier</Radio>
                  <Radio value="customer">Customer</Radio>
                </Radio.Group>
              </Form.Item>

              {form.getFieldValue("discountType") === "customer" && (
  <Form.Item
    label="Select Customer"
    name="customer"
    style={{ marginBottom: "10px" }}
    rules={[
      {
        required: true,
        message: "Please select a customer!",
      },
    ]}
  >
    <Select
      loading={!allCustomer}
      showSearch
      placeholder="Select a customer"
      optionFilterProp="children"
      onChange={(value) => setSelectedCustomer(value)}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      {allCustomer &&
        allCustomer.map((customer) => (
          <Select.Option key={customer.id} value={customer.id}>
            {customer.name}
          </Select.Option>
        ))}
    </Select>
  </Form.Item>
)}

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Publisher"
                name="publisher"
                rules={[
                  {
                    required: true,
                    message: "Please enter publisher!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Discount %"
                name="discountPercentage"
                rules={[
                  {
                    required: true,
                    message: "Please enter discount percentage!",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>

              <Form.Item className={styles.addProdCatBtnContainer}>
                <Button loading={loading} onClick={onClick} type="primary" htmlType="submit" shape="round">
                  Add Discount
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={11} xl={11} className="rounded column-design">
          <Card bordered={false} className={styles.importCsvCard}>
            <Title level={4} className="m-2 text-center">
              Import From CSV
            </Title>
            <UploadMany urlPath={"currency"} />
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddPartyDiscount;
